import AudioTranscriptText from '@modules/feedback/components/AudioType/AudioTranscript/AudioTranscriptText';
import useFeedbackListStore from '@modules/feedback/store/useFeedbackListStore';
import { Highlight } from '@modules/feedback/types';
import { Box, Button, Stack } from '@mui/material';
import { Feedback, FeedbackContentType } from 'v2/core/entities/feedback';
import { AudioTranscriptButton } from './AudioTranscriptButton';

interface AudioTranscriptSubtitleViewProps {
  feedback: Feedback;
  onExpand: () => void;
  highlights: { [key: string]: Highlight[] };
}

export const AudioTranscriptSubtitleView = ({
  feedback,
  onExpand,
  highlights,
}: AudioTranscriptSubtitleViewProps) => {
  const currentPlayingMsgIndex = useFeedbackListStore(
    (state) => state.feedbacks[feedback.id]?.currentPlayingMsgIndex ?? 0,
  );

  if (feedback.content.type !== FeedbackContentType.Audio) {
    return null;
  }

  const currentPlayingMsg = feedback.content.audioConversationEn.find(
    (_, index) => index === currentPlayingMsgIndex,
  );

  return (
    <Button
      onClick={onExpand}
      fullWidth
      sx={{ justifyContent: 'flex-start', py: 1 }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <AudioTranscriptButton onClick={onExpand} />
        <Box maxHeight="80px" overflow="auto">
          <AudioTranscriptText
            index={currentPlayingMsgIndex}
            text={currentPlayingMsg?.text ?? ''}
            highlights={highlights}
            showOriginalLanguage={false}
            actorName={currentPlayingMsg?.actorName}
            variant="body2"
          />
        </Box>
      </Stack>
    </Button>
  );
};
